import { render, staticRenderFns } from "./advicePage.vue?vue&type=template&id=54e20d72&scoped=true"
import script from "./advicePage.vue?vue&type=script&lang=js"
export * from "./advicePage.vue?vue&type=script&lang=js"
import style0 from "./advicePage.vue?vue&type=style&index=0&id=54e20d72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e20d72",
  null
  
)

export default component.exports